// NOTICE: KAPTION-INTEGRATION
// smart-assignment.MANUAL.1 — the manual trigger.
import ApiClient from './ApiClient';

class KaptionSmartAssignment extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  // smart-availability.PREFERRED.2 — a queue-aware picker sends the row the person clicked
  // as a hint; the resolver decides whether the pick stands. Both keys optional.
  resolve(conversationId, { preferredAssigneeId, preferredTeamId } = {}) {
    const payload = {};
    if (preferredAssigneeId)
      payload.preferred_assignee_id = preferredAssigneeId;
    if (preferredTeamId) payload.preferred_team_id = preferredTeamId;
    return this.post(`${conversationId}/smart_assign`, payload);
  }
}

export default new KaptionSmartAssignment();
